// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3neC2","header":"MergedInvoice_header__3-PLv"};